import React from "react";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(0),
      backgroundColor: "white",
    },
  })
);

export default function DownloadButton() {
  const classes = useStyles();

  return (
    <Button
      variant="outlined"
      color="primary"
      className={classes.button}
      startIcon={
        <FontAwesomeIcon color={"#4a90e2"} icon={faFileDownload} size={"lg"} />
      }
    >
      DOWNLOAD
    </Button>
  );
}
